module.exports = __webpack_public_path__ + "static/media/guideactive.9db5668e.png";